// Module
var code = "<span class=date-with-timezone title=\"{{'global.dateDirective.localTime.label' | translate}} {{(tooltip | date:format) || ('global.dateDirective.localTime.notAvailable' | translate)}}\">{{displayDate | rcDate:format}}</span>";
// Exports
module.exports = code;